import { Text, View } from '@react-pdf/renderer'
import React from 'react'

const TableSignature: React.FC = () => {

    return(

        <View break style = {{ width: '30%', borderTop: '1px solid black', marginTop: '100px'}} wrap={false}>
            <Text style = {{marginBottom: '2px', marginTop: '2px',fontSize: '10px'}}>FABIO HENRIQUE ERCOLIN</Text>
            <Text style = {{fontSize: '10px'}}>Coordenador de Monitoramento </Text>
            {/* <Text style = {{fontSize: '10px'}}>fabio@saneamento.com.br</Text> */}
        </View>



    )

}

export default TableSignature